import { RoleScreen } from '../features/roles/RoleScreen'
import { useShell } from '../app/outlet'

export function RolePage() {
  const { toast } = useShell()
  return <RoleScreen onToast={toast} />
}
